import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractTypePerPropertyTypeService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ContractTypePerPropertyTypeCreateDto,
  ContractTypePerPropertyTypeDto,
  ContractTypePerPropertyTypeExcelDownloadDto,
  ContractTypePerPropertyTypeUpdateDto,
} from '../proxy/controlling/dtos/contract-type-per-property-type';
import { CONTRACTTYPEPERPROPERTYTYPE_CONFIG, CONTRACTTYPEPERPROPERTYTYPE_FIELDS } from './contract-type-per-property-type.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-contract-type-per-property-type',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ContractTypePerPropertyTypeService, ConfirmationService],
  templateUrl: './contract-type-per-property-type.html',
  styleUrl: './contract-type-per-property-type.scss',
})
export class ContractTypePerPropertyType extends BaseHierarchicalCrudComponent<
  ContractTypePerPropertyTypeDto,
  ContractTypePerPropertyTypeCreateDto,
  ContractTypePerPropertyTypeUpdateDto,
  ContractTypePerPropertyTypeExcelDownloadDto
> {
  service = inject(ContractTypePerPropertyTypeService);
  config = CONTRACTTYPEPERPROPERTYTYPE_CONFIG;
  fields = CONTRACTTYPEPERPROPERTYTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ContractTypePerPropertyTypeDto): ContractTypePerPropertyTypeUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ContractTypePerPropertyType';
  }
}
